export const LOSS_TYPE = {
  RECIPE: 'recipe',
  SUPPLIER_PRODUCT: 'supplier_product',
  PRODUCT: 'product',
};
